<template>
    <div>
      <div class="level mgt-20px">
        <div class="level-left">
          <div class="columns">
            <div class="column is-narrow">
              <selecteur-action
                @handleAction="handleAction"
                :options='actions'
                :placeholder='$t("general.placeHolder.groupedAction")'
                :titleButton="'general.button.apply'"
                :elementsSelectionnes="hasASelection"
              ></selecteur-action>
            </div>
            <form @submit.prevent="recherche()" class="column is-3">
              <b-input :placeholder="$t('listeEcheancesAPayer.actions.search')"
                       type="search"
                       icon="magnify"
                       v-model="criteresRecherche.auto">
              </b-input>
            </form>
            <div class="column is-narrow">
              <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
                <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
                <span class="is-size-7">{{$t('general.button.filtre')}}
                  <label class="has-text-weight-bold"
                        :class="nombreCritere > 0 ? '' : 'is-invisible'">
                    ({{ nombreCritere }})
                  </label>
                </span>
              </button>
              <span @click="reinitialiserFiltre()"
                class="info-circle-right is-pulled-right is-cursor-pointer">
                <b-icon icon="close-circle" type="is-danger"></b-icon>
              </span>
            </div>
            <div class='column is-narrow'>
              <date-picker :dates='criteresRecherche.datesEcheance'
                           :triggerSearchEveryTime="false"
                           :updateEndDateAtChangeStartDate="false"
                           @recherche="recherche"/>
            </div>
          </div>
        </div>
        <div class="level-right columns">
          <div class="column is-narrow">
            <exportExcelButton
              :perm="permsEcheancierContrat.exporter"
              :query="exportExcelQuery"/>
          </div>
          <parametrage-table
            :reference-table="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
        </div>
      </div>
      <cumul-by-type-paiement :liste-paiement="this.echeancesAPayer"
                              v-if="cumulByTypeActionAchat"
                              :criteresRecherche="criteresRecherche"
                              :cumulByTypeActionAchat="cumulByTypeActionAchat"
        @updateFilters="updateFiltersForCumul">
      </cumul-by-type-paiement>
      <div class="level-right">
        <div class="lien mgb-20px has-text-right is-cursor-pointer"
            @click="displayOrMasquerEcheanceAnt()">
          {{ displayEcheancesAnt
          ? $t('listeEcheancesAPayer.masquerEchAnt')
          : $t('listeEcheancesAPayer.displayEchAnt',
            {total: totalEcheancesBeforeNow >= 0
                ? totalEcheancesBeforeNow : $t('general.enCoursCalcul') }) }}
        </div>
      </div>
      <v-server-table
        url=""
        :columns="columns"
        :options="options"
        :ref="referenceTable"
        @loaded="finLoading"
        @loading="debutLoading"
        v-if="startArrayRendering && mountedLoadingEnd"
        class="tableWithChildRow overflow-x-auto">
        <template slot='afterTable'>
          <table-items-in-view
            @input="$refs[referenceTable].setLimit($event)"
            :perPage="resultPerPage"/>
        </template>
        <template  #selected = "{ row }">
          <qd-checkbox
            :value="row.selected"
            class="has-text-centered"
            @input="selectionEcheanceAPayer(row)">
          </qd-checkbox>
        </template>
        <template  #codeAvenantBail = "{ row }">
          <router-link-blank :to="{ name: 'c.baux.contrat',
            params: {id: row.contratId}}"
            :message="row.codeAvenantBail">
          </router-link-blank>
        </template>
        <template  #codeMateriel = "{ row }">
          <router-link-blank :to="{ name: 'c.gabed.emplacement-detailMateriel',
            params: {idMateriel: row.materielId}}"
            :message="row.codeMateriel">
          </router-link-blank>
        </template>
        <template  #periodeEcheance = "{ row }">
          {{ row.dateDebutEcheance | formatDate }}
          {{ row.dateFinEcheance | formatDate }}
        </template>
        <template  #dateEcheance = "{ row }">
          {{ row.dateEcheance | formatDate }}
          <a v-if="!checkDateEcheanceInPeriode(row)">
            <div class="has-text-right"
              @click="setCommentaireList(row)">
              <b-icon type="is-warning" icon="alert" size="small"></b-icon>
            </div>
          </a>
        </template>
        <template  #dateFinContrat = "{ row }">
          {{ row.dateFinContrat | formatDate }}
        </template>
        <template  #contratEtat = "{ row }">
          {{ getContratEtat(row.contratEtat) }}
        </template>
        <template  #referencePaiement = "{ row }">
          <div class="has-text-editInTable">
            {{ getReferencePaiement(row.echeanceAPayerFaces) }}
          </div>
        </template>
        <template  #adresse = "{ row }">
          {{ getAdresse(row.echeanceAPayerFaces[0].adresseDispositif) }}
        </template>
        <template  #ville = "{ row }">
          <div v-if="row.echeanceAPayerFaces.length">
            {{ row.echeanceAPayerFaces[0].adresseDispositif.ville }}
          </div>
        </template>
        <template  #typeMaterielId = "{ row }">
          {{ getMaterielType(row.typeMaterielId) }}
        </template>
        <template  #formatMaterielId = "{ row }">
          {{ getMaterielFormat(row.formatMaterielId) }}
        </template>
        <template  #commentaireLigneCommande = "{ row }">
          <div class="has-text-editInTable ellipsis">
            {{ getCommentaireLigneCommande(row.echeanceAPayerFaces) }}
          </div>
        </template>
        <template  #commentaireCommande = "{ row }">
          <div class="has-text-editInTable ellipsis">
            {{ row.commentaireCommande }}
          </div>
        </template>
        <template  #bonAPayer = "{ row }">
          <div class="has-text-editInTable ellipsis">
            {{ getBAP(row.echeanceAPayerFaces) }}
          </div>
        </template>
        <template  #blocageReglement = "{ row }">
          {{ row.blocageReglement ?
          $t('listeEcheancesAPayer.yes') : $t('listeEcheancesAPayer.no') }}
        </template>
        <template  #montantEcheanceHt = "{ row }">
          <div class="has-text-right">
            {{ row.montantEcheanceHt | formatDevise }}
          </div>
        </template>
        <template  #montantEcheanceTtc = "{ row }">
          <div class="has-text-right">
            {{ row.montantEcheanceTtc | formatDevise }}
          </div>
        </template>
        <template  #modeReglement = "{ row }">
          {{ getModeReglement(row.modeReglementId) }}
        </template>
        <template  #validateur = "{ row }">
          <div class="has-text-editInTable">
            {{ findLibelleValidateur(row.echeanceAPayerFaces) }}
          </div>
        </template>
        <template  #indexation = "{ row }">
          <a
            v-if="row.valeurIndexationActuel"
            @click="showIndexationEcheancier(row)">
            <b-tooltip
              :label="$t('detailContrat.indexation.affichageDonneeIndexation')"
              position="is-top">
                <b-icon type="is-primary" icon="cash-plus" size="small"/>
            </b-tooltip>
          </a>
        </template>
        <template  #edit = "{ row }">
          <div class="has-text-centered">
            <btn-action-icon
              :permission="permsEcheancierContrat.maj"
              @is-click="editEcheanceAPayer(row.echeanceAPayerFaces)"
              icon-type="is-success"
              icon="pencil-box-outline">
            </btn-action-icon>
          </div>
        </template>
        <template  #actions = "{ row }">
          <verticalDotsDropdown
            :dropdownItems="dropdownItems(row)"
            :isButton="false"/>
        </template>
        <template v-slot:child_row="{ row }">
          <table-echeance-a-payer-face v-if="loadAffectation"
            class="overflow-x-auto"
            :data="row"
            @recherche="recherche"
            @actionSelected="selectionEcheanceAPayerChild($event, row)"
            @editEcheance="editEcheanceAPayer([$event])"
            @replanifier=" editEcheanceAReplanifier([$event])">
          </table-echeance-a-payer-face>
          <div v-else>
            <b-notification :closable="false">
              <b-loading :is-full-page="false" :active="true"></b-loading>
              <span>{{ $t('general.chargement') }}</span>
            </b-notification>
          </div>
        </template>
      </v-server-table>
      <transition name="custom-classes-transition"
        enter-active-class="animate__animated animate__slideInRight"
        leave-active-class="animate__animated animate__slideOutRight" :duration="10">
        <div class="componentBrief" v-show="showFiltre === true">
          <filtre-liste-echeances-a-payer ref="filtreListeEcheancesAPayer"
            @toggleFiltre="changeValueShowFiltreAndLockMenu()"
            @recherche="makeRechercheFilter"/>
        </div>
      </transition>
      <b-modal v-model="popUpEditEcheancesAPayer"
        has-modal-card>
        <pop-up-edit-echeances-a-payer
          :echeancesAPayer="echeancesAPayerAModifier"
          @updateOk="updateEcheances">
        </pop-up-edit-echeances-a-payer>
      </b-modal>
      <b-modal v-model="popUpReplanification"
               has-modal-card>
        <replanification-echeance-a-payer :echeancesAPayer="echeancesAPayerAModifier"
                                          @replanificationOk="closePopUpAndInformUser">
        </replanification-echeance-a-payer>
      </b-modal>
      <b-modal v-model="popUpCreationLotPaiement"
        has-modal-card>
        <creation-lot-paiement
          :echeances="echeancesAPayerAModifier"
          @refresh="closeAndSearch"/>
      </b-modal>
      <b-modal
          v-model="popUpIndexationEch"
          class="modal"
          has-modal-card
          @close="popUpIndexationEch = false">
              <pop-up-indexation-echeancier
                :echeancier="lineSelected"
                showDate
                @close="popUpIndexationEch = false"
              />
    </b-modal>
    <b-modal v-model="popUpInformationCommentaire" has-modal-card class="modal" :width="500">
      <information-commentaires :echeance="echeanceInfoCommentaire"></information-commentaires>
    </b-modal>
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import selecteurAction from '@/components/general/selecteurAction';
import TableItemsInView from '@/components/general/TableItemsInView';
import datePicker from '@/components/general/datePicker';
import filtreListeEcheancesAPayer from '@/components/baux/echeancesAPayer/filtreListeEcheancesAPayer';
import informationCommentaires from '@/components/baux/contrat/componentEdition/p_informationCommentaires';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import popUpEditEcheancesAPayer from '@/components/baux/echeancesAPayer/p_editEcheancesAPayer';
import replanificationEcheanceAPayer from '@/components/baux/echeancesAPayer/p_replanificationEcheanceAPayer';
import creationLotPaiement from '@/components/baux/echeancesAPayer/p_creationLotPaiement';
import { NO_PER_PAGE_VALUE, SORT_ICON, TEXTS } from '@/configuration/clientTableConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import {
  SET_DATES_ECHEANCES_SAVE,
  SET_DISPLAY_ECHECHEANCES_ANT,
} from '@/store/modules/baux/echeancesAPayer-mutation-type';
import snackBarSuccess from '@/services/general/snackbar/snackBarSuccess';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { LISTE_ETAT_CONTRAT } from '@/configuration/baux/contrat/contratConf';
import messageErreur from '@/services/general/messageErreur';
import {
  ACTION_EDIT,
  ACTION_LOT_PAIEMENT_CREATION,
  ACTION_REPLANNIFER, RESULTS_PER_PAGE_ECHEANCES,
} from '@/configuration/baux/echeancesAPayer/echeancesAPayerConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import { ECHEANCIER_CONTRAT } from '@/configuration/baux/permissionsBauxConf';
import genererEcheancierContrat from '@/services/baux/contrat/genererEcheancierContrat';
import { getEcheancierContrat } from '@/api/commandeAchat';
import cumulByTypePaiement from '@/components/baux/paiement/cumulByTypePaiement';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_ECHEANCES_A_PAYER } from '@/configuration/general/referenceTableConf';
import popUpIndexationEcheancier from '@/components/baux/contrat/componentDetail/popUpIndexationEcheancier';
import BtnActionIcon from '@/components/general/btnActionIcon';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';
import {
  getAffectationEcranNumerique,
  getAffectationProduitUnitaireAsync,
} from '@/api/affectation';
import formatIsoDate from '@/services/general/formatIsoDate';
import { CATEGORIE_UNITAIRE } from '@/configuration/catalogue/produitConf';
import tableEcheanceAPayerFace from './tableEcheanceAPayerFace';

const EcheancesAPayer = createNamespacedHelpers('echeancesAPayer');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      loadingComponent: null,
      unsubscribeValue: null,
      showFiltre: false,
      permsEcheancierContrat: ECHEANCIER_CONTRAT,
      affectations: [],
      codeFace: null,
      popUpInformationCommentaire: false,
      echeancier: genererEcheancierContrat(),
      echeanceInfoCommentaire: {},
      echeancesAPayerAModifier: [],
      popUpEditEcheancesAPayer: false,
      popUpReplanification: false,
      popUpAffectationsFace: false,
      produitInformation: null,
      popUpCreationLotPaiement: false,
      loadAffectation: false,
      actions: [
        { action: ACTION_EDIT, translation: 'listeEcheancesAPayer.actions.edit' },
        { action: ACTION_REPLANNIFER, translation: 'listeEcheancesAPayer.actions.replanifier' },
        { action: ACTION_LOT_PAIEMENT_CREATION, translation: 'listeEcheancesAPayer.actions.creationLotPaiement' },
      ],
      resultPerPage: RESULTS_PER_PAGE_ECHEANCES,
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_ECHEANCES_A_PAYER,
      mountedLoadingEnd: false,
      popUpIndexationEch: false,
      lineSelected: null,
    };
  },
  components: {
    selecteurAction,
    TableItemsInView,
    datePicker,
    informationCommentaires,
    filtreListeEcheancesAPayer,
    routerLinkBlank,
    popUpEditEcheancesAPayer,
    replanificationEcheanceAPayer,
    creationLotPaiement,
    cumulByTypePaiement,
    exportExcelButton,
    parametrageTable,
    popUpIndexationEcheancier,
    tableEcheanceAPayerFace,
    BtnActionIcon,
    verticalDotsDropdown,
  },
  methods: {
    ...EcheancesAPayer.mapActions({
      loadEcheancesAPayer: 'loadEcheancesAPayer',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...EcheancesAPayer.mapMutations({
      setDisplayEcheanceAnt: SET_DISPLAY_ECHECHEANCES_ANT,
      setDatesEcheancesSave: SET_DATES_ECHEANCES_SAVE,
    }),
    showIndexationEcheancier(ligne) {
      this.lineSelected = ligne;
      this.popUpIndexationEch = true;
    },
    getAdresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
    checkDateEcheanceInPeriode(row) {
      return moment(row.dateEcheance).isBetween(
        moment(row.dateDebutEcheance), moment(row.dateFinEcheance), 'day', '[]',
      );
    },
    updateFiltersForCumul(params) {
      this.criteresRecherche.bonAPayer = params.bap;
      this.criteresRecherche.modesReglementsIds = this.parametre(PARAMETRES_KEYS.modeReglement)
        .filter((modeReglement) => {
          return modeReglement.actionAchat === params.actionAchat;
        })
        .map((modeReglement) => {
          return modeReglement.id;
        });
      this.recherche();
    },
    updateEcheances() {
      this.popUpEditEcheancesAPayer = false;
      this.deselectAll();
      this.successUpdateEcheances();
    },
    async setCommentaireList(row) {
      const echeancier = (await getEcheancierContrat(row.contratId)).data.result;
      const echeancierMatchWithCmdId = echeancier
        .filter((e) => e.devisCommandeId === row.commandeId);
      const allCommentaires = echeancierMatchWithCmdId.flatMap(e => e.commentaires);
      this.echeanceInfoCommentaire = {
        ...echeancier[0],
        commentaires: allCommentaires,
      };
      this.popUpInformationCommentaire = true;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_REPLANNIFER:
          this.editEcheanceAReplanifier(this.echeancesAPayerSelected);
          break;
        case ACTION_EDIT:
          this.editEcheanceAPayer(this.echeancesAPayerSelected);
          break;
        case ACTION_LOT_PAIEMENT_CREATION:
          this.launchPopUpCreationLotPaiement(this.echeancesAPayerSelected);
          break;
        default:
          break;
      }
    },
    displayOrMasquerEcheanceAnt() {
      this.setDisplayEcheanceAnt(!this.displayEcheancesAnt);
      if (this.displayEcheancesAnt) {
        this.setDatesEcheancesSave(cloneDeep(this.criteresRecherche.datesEcheance));
        this.criteresRecherche.datesEcheance.dateDebut = null;
        this.criteresRecherche.datesEcheance.dateFin = new Date();
      } else this.criteresRecherche.datesEcheance = cloneDeep(this.datesEcheancesSave);
      this.recherche();
    },
    closePopUpAndInformUser() {
      this.popUpReplanification = false;
      this.successUpdateEcheances();
    },
    successUpdateEcheances() {
      snackBarSuccess(
        this.$i18n.t('listeEcheancesAPayer.messages.successEdit'),
        this.$i18n.t('listeEcheancesAPayer.actions.reload'),
        () => {
          this.recherche();
        },
      );
    },
    closeAndSearch() {
      this.popUpCreationLotPaiement = false;
      this.recherche();
    },
    launchPopUpCreationLotPaiement(echeances) {
      this.popUpCreationLotPaiement = true;
      this.echeancesAPayerAModifier = echeances;
    },
    editEcheanceAReplanifier(echeances) {
      this.echeancesAPayerAModifier = echeances;
      this.popUpReplanification = true;
    },
    editEcheanceAPayer(echeances) {
      this.echeancesAPayerAModifier = echeances;
      this.popUpEditEcheancesAPayer = true;
    },
    findLibelleValidateur(echeanceAPayerFaces) {
      const validateurIds = [...new Set(echeanceAPayerFaces.flatMap(e => e.validateur))];
      if (!validateurIds.length) return '';
      if (validateurIds.length === 1 || validateurIds.every(val => val === validateurIds[0])) {
        const nomsUniques = [];
        validateurIds.forEach((id) => {
          const user = this.parametre(PARAMETRES_KEYS.utilisateur)
            .find(utilisateur => utilisateur.id === id);
          if (user) {
            nomsUniques.add(nomPrenomGetter(user));
          }
        });
        return [...new Set(nomsUniques)].join(', ');
      }

      return this.$t('listeEcheancesAPayer.tab.voirDetail');
    },
    getContratEtat(etatContrat) {
      const etatContratFind = LISTE_ETAT_CONTRAT.find((etat) => {
        return etat.code === etatContrat;
      });
      return etatContratFind ? this.$i18n.t(etatContratFind.libelle) : '';
    },
    getModeReglement(id) {
      const modeReglementFind = this.parametre(PARAMETRES_KEYS.modeReglement)
        .find((modeReglement) => {
          return modeReglement.id === id;
        });
      return modeReglementFind ? modeReglementFind.libelle : '';
    },
    deselectAll() {
      this.echeancesAPayer.forEach((el) => {
        el.selected = false;
        el.echeanceAPayerFaces.forEach((f) => { f.selected = el.selected; });
      });
    },
    selectAll() {
      const select = !this.echeancesAPayer.every(e => e.selected);
      this.echeancesAPayer.forEach((el) => {
        el.selected = select;
        el.echeanceAPayerFaces.forEach((f) => { f.selected = select; });
      });
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeEcheancesAPayer.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    finLoading() {
      this.loadingComponent.close();
      this.initialiseAffectation();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.loadAffectation = false;
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPageAndCheckChangement() {
      if (this.criteresRecherche.agencesIds.length === 0) return;
      const agencesIds = [];
      this.criteresRecherche.agencesIds.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesIds.push(id);
      });
      this.criteresRecherche.agencesIds = agencesIds;
      this.$refs[this.referenceTable].setPage(1);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeEcheancesAPayer.initializeFiltre();
      this.$refs.filtreListeEcheancesAPayer.viderCritere();
      this.$refs.filtreListeEcheancesAPayer.appliquerCritere();
      this.showFiltre = false;
    },
    selectionEcheanceAPayer(row) {
      this.echeancesAPayer.forEach((e) => {
        if (e.id === row.id) {
          e.selected = !e.selected;
          e.echeanceAPayerFaces.forEach((f) => { f.selected = e.selected; });
        }
      });
    },
    selectionEcheanceAPayerChild(child, row) {
      row.echeanceAPayerFaces.forEach((e) => {
        if (e.id === child.id) e.selected = !child.selected;
      });
      row.selected = row.echeanceAPayerFaces.every((e) => e.selected);
    },
    getMaterielType(typeId) {
      return this.parametre(PARAMETRES_KEYS.materielType)
        .find(type => type.id === typeId)?.libelle ?? '';
    },
    getMaterielFormat(formatId) {
      return this.parametre(PARAMETRES_KEYS.materielFormat)
        .find(format => format.id === formatId)?.libelle ?? '';
    },
    dropdownItems(row) {
      return [
        {
          action: () => { this.editEcheanceAReplanifier(row.echeanceAPayerFaces); },
          libelle: this.$t('listeEcheancesAPayer.actions.replanifier'),
          permission: this.permsEcheancierContrat.maj,
        },
      ];
    },
    getCommentaireLigneCommande(echeanceAPayerFaces) {
      const commentaires = echeanceAPayerFaces.map(e => e.commentaireLigneCommande);
      if (commentaires.length === 0) return '';
      if (commentaires.length === 1
        || commentaires.every(val => val === commentaires[0])) {
        return commentaires[0] || '';
      }
      return this.$t('listeEcheancesAPayer.tab.voirDetail');
    },
    getReferencePaiement(echeanceAPayerFaces) {
      const referencePaiements = echeanceAPayerFaces.map(e => e.referencePaiement);
      if (referencePaiements.length === 0) return '';
      if (referencePaiements.length === 1
        || referencePaiements.every(val => val === referencePaiements[0])) {
        return referencePaiements[0] || '';
      }
      return this.$t('listeEcheancesAPayer.tab.voirDetail');
    },
    getBAP(echeanceAPayerFaces) {
      const bonAPayers = echeanceAPayerFaces.flatMap(e => e.bonAPayer);
      if (bonAPayers.length === 1 || bonAPayers.every(val => val === bonAPayers[0])) {
        return bonAPayers[0] ? this.$t('listeEcheancesAPayer.yes') : this.$t('listeEcheancesAPayer.no');
      }
      return this.$t('listeEcheancesAPayer.tab.voirDetail');
    },
    async initialiseAffectation() {
      const echeanceProduitUnitaire = [];
      const echeanceProduitNumerique = [];
      this.echeancesAPayer.forEach((echeanceAPayer) => {
        echeanceAPayer.echeanceAPayerFaces.forEach((echFace) => {
          if (!echFace.produitId) return;
          if (echFace.typeProduit === CATEGORIE_UNITAIRE) {
            echeanceProduitUnitaire.push({
              id: echFace.produitId,
              dureeAffectation: {
                dateDebut: formatIsoDate(echeanceAPayer.dateDebutEcheance),
                dateFin: formatIsoDate(echeanceAPayer.dateFinEcheance),
              },
            });
          } else {
            echeanceProduitNumerique.push({
              id: echFace.produitId,
              dureeAffectation: {
                dateDebut: formatIsoDate(echeanceAPayer.dateDebutEcheance),
                dateFin: formatIsoDate(echeanceAPayer.dateFinEcheance),
              },
            });
          }
        });
      });
      const affectationsUnitaire = (await getAffectationProduitUnitaireAsync(
        echeanceProduitUnitaire, false, true,
      )).data.result;
      const affectationsEcranNumerique = (await getAffectationEcranNumerique(
        echeanceProduitNumerique, false,
      )).data.result;

      this.echeancesAPayer.forEach((echeanceAPayer) => {
        echeanceAPayer.echeanceAPayerFaces.forEach((echFace) => {
          if (echFace.typeProduit === CATEGORIE_UNITAIRE) {
            echFace.affectations = affectationsUnitaire[echFace.produitId];
          } else {
            echFace.affectations = affectationsEcranNumerique[echFace.produitId];
          }
        });
      });
      this.loadAffectation = true;
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...EcheancesAPayer.mapGetters({
      criteresRecherche: 'criteresRecherche',
      cumulByTypeActionAchat: 'cumulByTypeActionAchat',
      echeancesAPayer: 'items',
      totalCount: 'total',
      totalEcheancesBeforeNow: 'totalEcheancesBeforeNow',
      displayEcheancesAnt: 'displayEcheancesAnt',
      datesEcheancesSave: 'datesEcheancesSave',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    hasASelection() {
      return this.echeancesAPayer.some(e => e.echeanceAPayerFaces.some(f => f.selected));
    },
    echeancesAPayerSelected() {
      return this.echeancesAPayer
        .flatMap(e => e.echeanceAPayerFaces.filter(f => f.selected));
    },
    iconSelectTotal() {
      if (this.echeancesAPayer.every(e => e.echeanceAPayerFaces.every(f => f.selected))) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    nombreCritere() {
      let nombreCritere = 0;
      if (this.criteresRecherche.modesReglementsIds.length > 0) nombreCritere += 1;
      if (this.criteresRecherche.agencesIds.length > 0) nombreCritere += 1;
      if (this.criteresRecherche.validateurs.length > 0) nombreCritere += 1;
      if (this.criteresRecherche.codeAvenantBail) nombreCritere += 1;
      if (this.criteresRecherche.codeFace) nombreCritere += 1;
      if (this.criteresRecherche.nomBailleur) nombreCritere += 1;
      if (this.criteresRecherche.montantEcheanceHt) nombreCritere += 1;
      if (this.criteresRecherche.montantEcheanceTtc) nombreCritere += 1;
      if (this.criteresRecherche.adresse) nombreCritere += 1;
      if (this.criteresRecherche.blocageReglement !== null) nombreCritere += 1;
      if (this.criteresRecherche.motifsBlocagesId.length > 0) nombreCritere += 1;
      if (this.criteresRecherche.commentaire) nombreCritere += 1;
      if (this.criteresRecherche.referencePaiement) nombreCritere += 1;
      if (this.criteresRecherche.bonAPayer) nombreCritere += 1;
      if (this.criteresRecherche.dateFinContrat.dateDebut
        || this.criteresRecherche.dateFinContrat.dateFin) nombreCritere += 1;
      if (this.criteresRecherche.etatContrat) nombreCritere += 1;
      if (this.criteresRecherche.villePanneau) nombreCritere += 1;
      if (this.criteresRecherche.estIndexe !== null) nombreCritere += 1;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    columns() {
      return ['selected', 'codeAvenantBail', 'indexation', 'codeMateriel', 'typeMaterielId', 'formatMaterielId', 'adresse', 'ville', 'dateEcheance', 'nomBailleur', 'montantEcheanceHt', 'montantEcheanceTtc', 'periodeEcheance', 'referencePaiement', 'bonAPayer', 'commentaireLigneCommande', 'validateur', 'contratEtat', 'dateFinContrat', 'blocageReglement', 'motifBlocage', 'modeReglement', 'commentaireCommande', 'edit', 'actions'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          codeAvenantBail: this.$i18n.t('listeEcheancesAPayer.tab.codeAvenantBail'),
          codeMateriel: this.$i18n.t('listeEcheancesAPayer.tab.codeMateriel'),
          typeMaterielId: this.$i18n.t('listeEcheancesAPayer.tab.materielType'),
          formatMaterielId: this.$i18n.t('listeEcheancesAPayer.tab.formatType'),
          adresse: this.$i18n.t('listeEcheancesAPayer.tab.adresse'),
          nomBailleur: this.$i18n.t('listeEcheancesAPayer.tab.nomBailleur'),
          periodeEcheance: this.$i18n.t('listeEcheancesAPayer.tab.periodeEcheance'),
          dateEcheance: this.$i18n.t('listeEcheancesAPayer.tab.dateEcheance'),
          dateFinContrat: this.$i18n.t('listeEcheancesAPayer.tab.dateFinBail'),
          contratEtat: this.$i18n.t('listeEcheancesAPayer.tab.etatBail'),
          blocageReglement: this.$i18n.t('listeEcheancesAPayer.tab.blocageReglement'),
          motifBlocage: this.$i18n.t('listeEcheancesAPayer.tab.motifBlocage'),
          montantEcheanceHt: this.$i18n.t('listeEcheancesAPayer.tab.montantEcheanceHT'),
          montantEcheanceTtc: this.$i18n.t('listeEcheancesAPayer.tab.montantEcheanceTTC'),
          modeReglement: this.$i18n.t('listeEcheancesAPayer.tab.modeReglement'),
          commentaireLigneCommande: this.$i18n.t('listeEcheancesAPayer.tab.commentaireLigneCommande'),
          commentaireCommande: this.$i18n.t('listeEcheancesAPayer.tab.commentaireCommande'),
          validateur: this.$i18n.t('listeEcheancesAPayer.tab.validateur'),
          ville: this.$i18n.t('listeEcheancesAPayer.tab.villePanneau'),
          referencePaiement: this.$i18n.t('listeEcheancesAPayer.tab.refPaiement'),
          bonAPayer: this.$i18n.t('listeEcheancesAPayer.tab.bonAPayer'),
          indexation: this.$i18n.t('listeEcheancesAPayer.tab.indexation'),
          actions: '',
          edit: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: { class: 'pointer' },
                on: { click: this.selectAll },
              },
              [h('b-icon', { attrs: { icon: this.iconSelectTotal } })],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          if (this.criteresRecherche.agencesIds.length === 0) {
            data.query.agencesIds = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          return this.loadEcheancesAPayer(data);
        }),
        columnsClasses: {
          commentaireLigneCommande: 'colonneCommentaire',
          commentaireCommande: 'colonneCommentaire',
          dateEcheance: 'colonneWidth130px',
          edit: 'colonneSelected',
          actions: 'colonneSelected',
          bonAPayer: 'colonneWidth130px',
        },
        responseAdapter: (() => {
          return {
            data: this.echeancesAPayer,
            count: this.totalCount,
          };
        }),
        sortable: ['codeAvenantBail', 'codeFace', 'adresseProduit.ville', 'nomBailleur', 'dateEcheance', 'blocageReglement', 'motifBlocage', 'modeReglement', 'montantEcheanceHt', 'montantEcheanceTtc', 'commentaireCommande'],
        rowClassCallback: ((row) => {
          return this.checkDateEcheanceInPeriode(row) ? '' : 'background-warning-table';
        }),
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'echeancesapayer',
        Filtres: this.lastPayload,
      };
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPageAndCheckChangement);
      await this.loadParametreUtilisateur();
      await this.loadParametres([PARAMETRES_KEYS.modeReglement,
        PARAMETRES_KEYS.materielType, PARAMETRES_KEYS.materielFormat,
      ]);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
